import { render, staticRenderFns } from "./UpNextListDesktop.vue?vue&type=template&id=453d5a28&scoped=true&"
import script from "./UpNextListDesktop.vue?vue&type=script&lang=js&"
export * from "./UpNextListDesktop.vue?vue&type=script&lang=js&"
import style0 from "./UpNextListDesktop.vue?vue&type=style&index=0&id=453d5a28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d5a28",
  null
  
)

export default component.exports